/**
 * @module CTA Banner
 * @description
 */
import PropTypes from "prop-types";
import DynamicButton from "@/blocks/Buttons/DynamicButton";
import styles from "./BannerCTA.module.css";

const position = "BANNER CTA";

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const { copy, theme = null, usePhone = false, location, link } = props;

  return (
    <section
      className={`component ${styles.component} ${theme && `u-theme-${theme}`}`}
    >
      <div className="l-container">
        <div className={styles.component__body}>
          {copy && <p className={styles.component__copy}>{copy}</p>}
          <DynamicButton
            type={usePhone ? "phone" : "cart"}
            position={position}
            location={location}
            title={link?.title}
          />
        </div>
      </div>
    </section>
  );
};

Component.propTypes = {
  copy: PropTypes.string,
  theme: PropTypes.string,
  usePhone: PropTypes.bool,
  location: PropTypes.string,
};

export default Component;
